import './App.css';
import About from './Screens/About';
import Contact from './Screens/Contact';
import Navbar from './Components/Navbar';
import Work from './Screens/Work';
import Experience from './Screens/Experience';
import Alert from './Screens/Alert';

import { Helmet } from "react-helmet"
import { useState } from 'react';

import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import Home from './Screens/Home';


function App() {

  const [alert, setalert] = useState(null);

  const showAlert = (message, color) => {
    setalert({
      msg: message,
      type: color
    })
    setTimeout(() => {
      setalert(null);
    }, 3000);
  }

  return (
    <>
      <Router>

        <Navbar />
        <Alert alert={alert} />

        <Switch>
          <Route exact path='/'><Home /></Route>
          <Route exact path='/about'><About /></Route>
          <Route exact path='/experience'><Experience /></Route>
          <Route exact path='/work'><Work /></Route>
          <Route exact path='/contact'><Contact showAlert={showAlert} /></Route>
        </Switch>

        <Helmet>
          <script src='../Js/Cursor.js'></script>
          <script src='../Js/Disable.js'></script>
        </Helmet>

      </Router>

    </>

  );
}

export default App;
